/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RecentButton_viewer$ref: FragmentReference;
declare export opaque type RecentButton_viewer$fragmentType: RecentButton_viewer$ref;
export type RecentButton_viewer = {|
  +id: string,
  +backendId: ?number,
  +$refType: RecentButton_viewer$ref,
|};
export type RecentButton_viewer$data = RecentButton_viewer;
export type RecentButton_viewer$key = {
  +$data?: RecentButton_viewer$data,
  +$fragmentRefs: RecentButton_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecentButton_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = 'd4a40b06261a8d0ccdab09d4da598c00';

module.exports = node;
